import React from "react";
import { Helmet } from "react-helmet";

function Madurai() {
  return (
    <div style={{ padding: "20px" }}>
      <Helmet>
        <title>Affordable Catering Services in Madurai | Chettinad Catering</title>
        <meta
          name="description"
          content="Best catering services in Madurai by Sevvur Pandiyan Catering. We offer wedding catering, veg and non-veg catering, and party catering at affordable prices."
        />
      </Helmet>

      <h1>Affordable Catering Services in Madurai</h1>

      <p>
        Sevvur Pandiyan Catering offers top-quality catering services in Madurai
        for weddings, functions, and parties with authentic Chettinad cuisine.
      </p>

      <h2>Our Services</h2>
      <ul>
        <li>Wedding Catering in Madurai</li>
        <li>Engagement and Function Catering</li>
        <li>Birthday Catering</li>
        <li>Veg and Non-Veg Catering</li>
      </ul>

      <h2>Best Chettinad Catering</h2>
      <p>
        We bring traditional Chettinad taste with modern hygiene standards and
        excellent service.
      </p>

      <h2>Contact Us</h2>
      <p>Book affordable catering services in Madurai today!</p>
    </div>
  );
}

export default Madurai;